// New Canvas Video Modal - Decoupled from product-canvas
// Handles video modal functionality for the new-canvas section

// Detect if device is mobile
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
         (window.innerWidth <= 768 && 'ontouchstart' in window);
}

function getNcVideoContent() {
  // Get video settings from window variables set by Liquid
  const videoUrl = window.ncVideoUrl || '';
  const externalVideoUrl = window.ncExternalVideoUrl || '';
  const isMobile = isMobileDevice();
  
  if (externalVideoUrl) {
    // Handle external video URLs (YouTube, TikTok, etc.)
    if (externalVideoUrl.includes('youtube.com') || externalVideoUrl.includes('youtu.be')) {
      const videoId = extractNcYouTubeId(externalVideoUrl);
      if (!videoId) {
        return '<p>Invalid YouTube URL</p>';
      }
      // Don't autoplay on mobile - user must click play button
      const autoplayParam = isMobile ? 'autoplay=0' : 'autoplay=1';
      return `<iframe 
        width="100%" 
        height="100%" 
        src="https://www.youtube.com/embed/${videoId}?${autoplayParam}&mute=1&rel=0" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
        class="nc-external-video-iframe">
      </iframe>`;
    } else if (externalVideoUrl.includes('tiktok.com')) {
      const embedUrl = externalVideoUrl.replace('https://www.tiktok.com/', 'https://www.tiktok.com/embed/');
      return `<iframe 
        width="100%" 
        height="100%" 
        src="${embedUrl}" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
        class="nc-external-video-iframe">
      </iframe>`;
    } else {
      // Generic external video
      return `<iframe 
        width="100%" 
        height="100%" 
        src="${externalVideoUrl}" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
        class="nc-external-video-iframe">
      </iframe>`;
    }
  } else if (videoUrl && videoUrl.sources && videoUrl.sources.length > 0) {
    // Handle Shopify video
    const mp4Source = videoUrl.sources.find(s => s.mime_type && s.mime_type.includes('mp4')) || videoUrl.sources[0];
    const webmSource = videoUrl.sources.find(s => s.mime_type && s.mime_type.includes('webm'));
    
    // Don't autoplay on mobile - user must click play button
    const autoplayAttr = isMobile ? '' : 'autoplay';
    let videoHTML = `<video 
      controls
      width="100%" 
      height="100%" 
      preload="none" 
      ${autoplayAttr}
      muted
      poster="${mp4Source.url}"
      class="nc-gallery-video"
    >`;
    
    if (webmSource) {
      videoHTML += `<source src="${webmSource.url}" type="video/webm">`;
    }
    videoHTML += `<source src="${mp4Source.url}" type="video/mp4">
      Your browser does not support the video tag.
    </video>`;
    
    return videoHTML;
  }
  
  return '<p>No video available</p>';
}

function extractNcYouTubeId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
}

function setupNcVideoModal() {
  console.log('🎥 [NC] Setting up new canvas video modal...');
  
  const trigger = document.querySelector('[data-nc-video-modal-trigger]');
  const modal = document.getElementById('nc-video-modal');
  
  console.log('🎥 [NC] Trigger found:', !!trigger);
  console.log('🎥 [NC] Modal found:', !!modal);
  
  if (!trigger || !modal) {
    console.log('🎥 [NC] Modal setup failed - missing trigger or modal element');
    return;
  }
  
  // Prevent modal from opening on page load if URL has hash (coming from external links)
  // This prevents accidental triggers when users arrive from Instagram or other sources
  const urlHash = window.location.hash;
  if (urlHash && urlHash !== '') {
    console.log('🎥 [NC] URL has hash, preventing accidental modal trigger:', urlHash);
    // Clear the hash to prevent navigation issues
    if (history.replaceState) {
      history.replaceState(null, null, ' ');
    }
  }
  
  // Insert video content into modal
  const videoContainer = modal.querySelector('.nc-video-modal__video-container');
  if (videoContainer) {
    videoContainer.innerHTML = getNcVideoContent();
  }
  
  const closeButtons = modal.querySelectorAll('[data-nc-video-modal-close]');
  const video = modal.querySelector('video');
  const iframe = modal.querySelector('iframe');
  
  // Function to open modal (extracted for reuse)
  function openModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    console.log('🎥 [NC] Modal trigger clicked!');
    console.log('🎥 [NC] Setting modal display to flex');
    modal.style.display = 'flex';
    console.log('🎥 [NC] Modal display after setting:', modal.style.display);
    
    // Lock body scroll
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '0';
    
    // Auto-play video when modal opens (only on desktop, not mobile)
    // On mobile, user must click the play button manually
    const isMobile = isMobileDevice();
    if (video && !isMobile) {
      video.play().catch(function(error) {
        console.log('🎥 [NC] Auto-play failed:', error);
      });
    } else if (video && isMobile) {
      console.log('🎥 [NC] Mobile device detected - video will not auto-play');
    }
  }
  
  // Track touch events to distinguish taps from scrolls
  let touchStartTime = 0;
  let touchStartY = 0;
  let isScrolling = false;
  
  // Track touchstart for mobile
  trigger.addEventListener('touchstart', function(e) {
    touchStartTime = Date.now();
    touchStartY = e.touches[0].clientY;
    isScrolling = false;
  }, { passive: true });
  
  // Track touchmove to detect scrolling
  trigger.addEventListener('touchmove', function(e) {
    const touchY = e.touches[0].clientY;
    const touchDistance = Math.abs(touchY - touchStartY);
    if (touchDistance > 5) {
      isScrolling = true;
    }
  }, { passive: true });
  
  // Handle touchend - only open if it's a deliberate tap, not a scroll
  trigger.addEventListener('touchend', function(e) {
    const touchDuration = Date.now() - touchStartTime;
    const touchEndY = e.changedTouches[0].clientY;
    const touchDistance = Math.abs(touchEndY - touchStartY);
    
    // Only open modal if it's a quick tap (not a scroll) and intentional
    if (!isScrolling && touchDuration < 300 && touchDistance < 10) {
      e.preventDefault();
      e.stopPropagation();
      openModal(e);
    }
    // Reset scroll flag
    isScrolling = false;
  }, { passive: false });
  
  // Open modal on click (for desktop and non-touch devices)
  trigger.addEventListener('click', function(e) {
    // Only handle click if it wasn't already handled by touchend
    // Check if this is a touch device by checking if touchend was recent
    const timeSinceTouch = Date.now() - touchStartTime;
    if (timeSinceTouch > 100) {
      // Not a touch event, handle as regular click
      openModal(e);
    }
  }, { passive: false });
  
  // Handle keyboard accessibility (Enter and Space keys)
  trigger.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      openModal(e);
    }
  });
  
  // Close modal
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeNcModal();
    });
  });
  
  // Close on overlay click
  modal.addEventListener('click', function(e) {
    if (e.target === modal || e.target.classList.contains('nc-video-modal__overlay')) {
      closeNcModal();
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeNcModal();
    }
  });
  
  function closeNcModal() {
    modal.style.display = 'none';
    
    // Restore body scroll
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    
    // Pause video when modal closes
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }
}

// Make function globally available
window.setupNcVideoModal = setupNcVideoModal;

